import { getDefaultDateRange } from '../../../../utils/getDefaultDateRange'
import { IMatchingPayoutFilters, MATCHING_PAYOUT_DATE_MODE } from './matchingPayout.types'

export const MATCHING_PAYOUT_PER_PAGE = 20

/**
 * Дефолты фильтра. Период берётся из `getDefaultDateRange()` — он якорится на московские
 * стенные часы, как и быстрые кнопки `dateRange` (`calculateQuickRange` → `getMoscowDateTime`).
 */
export const getMatchingPayoutDefaultFilters = (): IMatchingPayoutFilters => {
  const { startDate, endDate } = getDefaultDateRange()

  return {
    dateRange: { from: startDate, to: endDate, mode: MATCHING_PAYOUT_DATE_MODE.created },
    merchantTokenList: [],
    paymentAdapterIdList: [],
    paymentMethods: [],
    outcomes: [],
  }
}
